import React from 'react'
import { Select, MenuItem, FormControl, ListItemIcon, ListItemText } from '@mui/material'
import { Icon } from '@iconify/react/dist/iconify.js'
import { ChevronDown } from 'lucide-react'
import './IconSelect.scss'

export default function IconSelect({ label, value, options, onChange, placeholder = 'Select option', className }) {
  // Helper to normalize each option into an object with value, label, and optional icon
  const getOption = (option) => {
    if (!option) {
      return { value: '', label: '', icon: undefined }
    }
    if (typeof option === 'string') {
      // If it's a string, check if it looks like an iconify icon (contains : )
      const isIcon = option.includes(':')
      return {
        value: option,
        label: option,
        icon: isIcon ? option : undefined
      }
    }
    return {
      value: option.value,
      label: option.label || option.value,
      icon: option.icon
    }
  }

  const normalizedOptions = (options || []).map(getOption)
  const selectedOption = normalizedOptions.find(opt => opt.value === value) || getOption(value)

  return (
    <div className="sr-select-wrap icon-select">
      {label && <label>{label}</label>}
      <Select
        className={className || "sr-select"}
        variant="standard"
        disableUnderline
        value={value}
        onChange={onChange}
        displayEmpty
        IconComponent={ () => <ChevronDown size={16} className="sr-select-wrap__icon" />}
        renderValue={(selected) => {
          if (!selected) return <span className="sr-select__placeholder">{placeholder}</span>
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {selectedOption.icon && <Icon icon={selectedOption.icon} size={20} />}
              <span>{selectedOption.label}</span>
            </div>
          )
        }}
        MenuProps={{
          PaperProps: {
            className: 'icon-select-menu'
          }
        }}
      >
        {normalizedOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.icon && (
              <ListItemIcon style={{ minWidth: 'auto', marginRight: '8px' }}>
                <Icon icon={option.icon} size={20} />
              </ListItemIcon>
            )}
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
      {/* <ChevronDown size={16} className="sr-select-wrap__icon" /> */}
    </div>
  )
}
